import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { IoBuild, IoAlertCircle, IoCheckmarkCircle } from "react-icons/io5";

import BcInvoiceSummaryRow from "./BcInvoiceSummaryRow";

const BcInvoiceSummarySection = ({ invoice, invoiceLines }) => {
  const isLineFlagged = (line) =>
    line?.lineType === "Item" &&
    line?.itemVariantId === "00000000-0000-0000-0000-000000000000";

  const flaggedInvoiceLines =
    invoiceLines?.filter(
      (line) =>
        line?.body?.lineType === "Item" &&
        line?.body?.itemVariantId === "00000000-0000-0000-0000-000000000000"
    )?.length || 0;
  const totalSuccessfullyCreatedInvoiceLines =
    invoiceLines?.filter((line) => line?.body?.description)?.length || 0;
  const totalFailedToCreateInvoiceLines =
    invoiceLines?.filter((line) => line?.body?.error)?.length || 0;
  const totalPreventedInvoiceLines =
    invoice.totalExpectedLines -
      (totalFailedToCreateInvoiceLines +
        totalSuccessfullyCreatedInvoiceLines) || 0;

  const getInvoiceStatusIcon = () => {
    if (totalFailedToCreateInvoiceLines > 0) {
      return (
        <IoAlertCircle
          size={20}
          style={{ color: "#fe703f", marginRight: "1rem" }}
        />
      );
    }
    if (totalPreventedInvoiceLines > 0) {
      return (
        <IoAlertCircle
          size={20}
          style={{ color: "#fe703f", marginRight: "1rem" }}
        />
      );
    }
    if (!invoice?.id) {
      return (
        <IoAlertCircle
          size={20}
          style={{ color: "#fe703f", marginRight: "1rem" }}
        />
      );
    }
    if (flaggedInvoiceLines > 0) {
      return (
        <IoBuild size={20} style={{ color: "#fe703f", marginRight: "1rem" }} />
      );
    }
    return (
      <IoCheckmarkCircle
        size={20}
        style={{ color: "#35d687", marginRight: "1rem" }}
      />
    );
  };

  return (
    <React.Fragment>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginTop: "2rem",
          borderBottom: "2px solid #50accb"
        }}
      >
        {getInvoiceStatusIcon()}
        <HeaderTextStyled>{`${invoice?.customerNumber}: ${
          invoice?.number || ""
        }`}</HeaderTextStyled>
        {!invoice?.id && <ErrorTextStyled>{invoice.message}</ErrorTextStyled>}
      </div>
      {invoiceLines && invoiceLines.length ? (
        <InvoiceSectionContainerStyled>
          {invoiceLines?.map((line) => (
            <BcInvoiceSummaryRow
              key={line?.id}
              line={line}
              isFlagged={isLineFlagged(line?.body)}
            />
          ))}
        </InvoiceSectionContainerStyled>
      ) : null}
    </React.Fragment>
  );
};

const ErrorTextStyled = styled.h5`
  color: ${(props) => props.theme.red_g};
  margin-left: 1rem;
`;

const HeaderTextStyled = styled.span`
  color: ${(props) => props.theme.blue_g};
  font-size: 20px;
`;

const InvoiceSectionContainerStyled = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  height: 25rem;
  width: 100%;
  overflow-y: auto;
`;

BcInvoiceSummarySection.propTypes = {
  invoice: PropTypes.object,
  invoiceLines: PropTypes.array
};

export default BcInvoiceSummarySection;
